export default __webpack_public_path__ + "static/media/es-cn.85d5d852.svg";